import { UntypedFormGroup } from "@angular/forms";
import Handsontable from "handsontable";
import { Cellstyle } from "~app/common/components/hot-doc/hotdoc/cell";
import { IHotDocSettings } from "~app/common/components/hot-doc/hotdoc/doc";
import { Produktmatris } from "../Produktmatris";
import { AbstractPrismatrisCell } from "./abstractPrismatrisCell";
import { FargCellChangeArg } from "./fargCellChangeArg";
import { IMarkningValue } from "./markingValue";
export class FargCell extends AbstractPrismatrisCell {
    value: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static attrRow = "data-row";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static attrRowIndex = "data-row-index";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static attrColumn = "data-col";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static attrColumnIndex = "data-col-index";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static isCheckboxListenerAdded = new WeakMap();

    constructor(
        prismatris: Produktmatris,
        form: UntypedFormGroup,
        private readonly cellAccessor: (row, col) => any,
        flags?: Cellstyle
    ) {
        super(prismatris, form, flags, null, (pm: FargCellChangeArg) => {
            const a = pm;
            this.prismatris.markning1 = a.newValue.markning1;
            this.prismatris.markning2 = a.newValue.markning2;
            this.prismatris.markning3 = a.newValue.markning3;
        });
    }

    changeArgumentFactory = (raw: any, onComplete: () => any, settings: IHotDocSettings) => new FargCellChangeArg(raw, onComplete);

    override onDelete(settings: IHotDocSettings): void {
        if (this.isReadonly) {
            return;
        }

        this.prismatris.markning1 = false;
        this.prismatris.markning2 = false;
        this.prismatris.markning3 = false;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        const changeArg = this.changeArgumentFactory(this.prismatris, () => { }, settings);
        this.onChange(changeArg);
    }

    renderer = (hot: Handsontable, td: HTMLTableCellElement, row: any, col: any, prop: any, value: any, cellProperties: any) => {
        this.applyStyle(td, cellProperties);
        td.style.paddingLeft = "3px";
        const markning1 = this.createInput(document, "markning1", row, col, cellProperties.readOnly);
        const markning2 = this.createInput(document, "markning2", row, col, cellProperties.readOnly);
        const markning3 = this.createInput(document, "markning3", row, col, cellProperties.readOnly);
        const rootElement = (hot as any).rootElement as Element;

        // Empty
        while (td.firstChild) {
            td.removeChild(td.firstChild);
        }

        const listener = FargCell.isCheckboxListenerAdded.get(hot);
        if (!listener) {
            rootElement.addEventListener("click", event => this.onChangeEvent(event, hot, this.cellAccessor));
            FargCell.isCheckboxListenerAdded.set(hot, "event");
        }

        td.appendChild(markning1);
        td.appendChild(markning2);
        td.appendChild(markning3);

        if ((hot.getSettings() as IHotDocSettings).readOnly) {
            cellProperties.readOnly = true;
        }
        return td;
    };

    validate(value: IMarkningValue): boolean {
        return !!value;
    }

    createInput(rootDocument: Document, field: string, rowIndex, colIndex, readonly) {
        const input = rootDocument.createElement("input");

        input.className = "htCheckboxRendererInput";
        input.type = "checkbox";
        input.setAttribute("name", field);
        input.setAttribute("autocomplete", "off");
        input.setAttribute("tabindex", "-1");
        if (this.prismatris[field]) {
            input.setAttribute("checked", "checked");
        }
        input.setAttribute(FargCell.attrRow, this.prismatris.startlangd.toString());
        input.setAttribute(FargCell.attrColumn, this.prismatris.startdiameter.toString());
        input.setAttribute(FargCell.attrRowIndex, rowIndex);
        input.setAttribute(FargCell.attrColumnIndex, colIndex);

        if (readonly) {
            input.setAttribute("disabled", "disabled");
        }

        return input.cloneNode(false);
    }

    onChangeEvent = (event, instance, cellAccessor: (row, col) => any) => {
        const { target } = event;

        if (!this.isCheckboxInput(target)) {
            return;
        }

        if (!target.hasAttribute(FargCell.attrRow) || !target.hasAttribute(FargCell.attrColumn)) {
            return;
        }

        const row = parseInt(target.getAttribute(FargCell.attrRow), 10);
        const rowIndex = parseInt(target.getAttribute(FargCell.attrRowIndex), 10);
        const col = parseInt(target.getAttribute(FargCell.attrColumn), 10);
        const colIndex = parseInt(target.getAttribute(FargCell.attrColumnIndex), 10);
        const field = target.getAttribute("name");

        const cell = cellAccessor(row, col) as Produktmatris;

        const value = event.target.checked;
        const arg: IMarkningValue = {
            markning1: cell.markning1,
            markning2: cell.markning2,
            markning3: cell.markning3
        };

        arg[field] = value;

        instance.setDataAtCell(rowIndex, colIndex, arg);

    };

    isCheckboxInput(element) {
        return element.tagName === "INPUT" && element.getAttribute("type") === "checkbox";
    }

    protected genHtml(): string {
        // Används ej i renderer
        return null;
    }
}
